const privadoLiquidarStore = {
  namespaced: true,
  state: () => ({
    list: [],
    liquidado: null,
    monedas: [],
  }),
  mutations: {
    load(state, { list, liquidado, monedas }) {
      state.list = list;
      state.liquidado = liquidado;
      state.monedas = monedas;
    },
    new(state) {
      state.list.push({
        isNew: true,
        id: new Date().getTime(),
        fecha: "",
        otroServicio: "",
        otroHotel: "",
        otroTipo: "",
        tarifa: "",
        observaciones: "",
        tempMoneda: "USD",
      });
    },
    updateList(state, list) {
      state.list = list;
    },
    setLiquidado(state, liquidado) {
      state.liquidado = liquidado;
    },
  },
  getters: {
    estaLiquidado(state) {
      return !!state.liquidado;
    },
    total(state) {
      const tienen_moneda = state.list.filter((item) => item.tempMoneda);

      const monedas = {};

      tienen_moneda.forEach((item) => {
        if (monedas[item.tempMoneda]) {
          monedas[item.tempMoneda] = monedas[item.tempMoneda] + Number(item.tarifa);
        } else {
          monedas[item.tempMoneda] = Number(item.tarifa);
        }
      });

      return monedas;
    },
    hayNuevos(state) {
      return state.list.some((item) => item.isNew);
    },
    monedas: (state) => state.monedas,
  },
  actions: {
    remove({ commit, state }, id) {
      const newList = state.list.filter((item) => item.id != id);
      commit("updateList", newList);
    },
    save({ commit, state }, liquidado) {
      const newList = state.list.map((item) => {
        if (item.isNew) {
          return {
            ...item,
            isNew: false,
            servicio: item.otroServicio,
            hotel: item.otroHotel,
            servicioTipo: item.otroTipo,
            moneda: item.tempMoneda,
          };
        }
        return {
          ...item,
          moneda: item.tempMoneda,
        };
      });

      commit("load", {
        list: newList,
        liquidado: liquidado,
      });
    },
  },
};

export default privadoLiquidarStore;
